import React, { useEffect, useRef, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { useTranslation } from 'react-i18next';
import { RouterProvider, useLocation } from 'react-router-dom';

import { MainLayout } from './layouts/MainLayout';
import { BaseRouter } from './routes/BaseRouter';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { setWindowWidth } from './store/features/displaySlice';
import { NotificationModal } from './components/common/NotificationModal';
import NotificationHub, { AddFunction } from './components/common/NotificationHub';
import { addNotification, NotificationItem, NotificationType, popNotification } from './store/features/notificationsSlice';
import axios from 'axios';
import { initAuthStateFromLocalStorage, setApiauthInitialized } from './store/features/authSlice';
import router from './routes/browserRouter';
import api from './api/apiInstance';
import { createSocket } from "./socket";
import { SOCKET_CONNECTION_TYPE } from './interfaces/websockets';
import { Socket } from 'socket.io-client';
import { makeTestRequest } from './api/requests/messages';
import { addIncomingInboxNotification, InboxNotificationModel, WebsocketInboxReceiveModel } from './store/features/inboxSlice';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { Spinner } from './components/common/Spinner';

function App() {
  const { t, i18n } = useTranslation("main");
  const dispatch = useAppDispatch();
  const displayType = useAppSelector((state) => state.display.displayWidth);
  const [prevNotifications, setPrevNotifications] = useState<NotificationItem[]>([]);
  const notifications = useAppSelector((state) => state.notifications.notifications);
  const scrollYEnabled = useAppSelector((state) => state.display.scrollYEnabled);
  const globalLoadingState = useAppSelector((state) => state.display.globalLoading);
  const authState = useAppSelector((state) => state.auth.user);
  const ref = useRef<null | AddFunction>(null);
  const [notificationsSocket, setNotificationsSocket] = useState<Socket | null>(null);
  const initialState = 0;

  if (process.env.REACT_APP_DEV_MODE !== 'true') {
    ReactGA.initialize('G-9WC15Q6QRS');
    console.log("GA initialized2");
  }

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const handleWindowResizeEvent = (e: any) => {
    dispatch(setWindowWidth(window.innerWidth))
  }

  useEffect(() => {
    console.log("LAUNCH APP ");

    // TODO: need to limit this request if already on inital app launc the new request is made so if this useeffect is called twice, user token could be invalidated
    // as one refresh token is expired
    dispatch(initAuthStateFromLocalStorage());

    dispatch(setWindowWidth(window.innerWidth))
    window.addEventListener('resize', (e) => handleWindowResizeEvent(e));

    return () => {
      window.removeEventListener('resize', (e) => handleWindowResizeEvent(e));
    };
  }, [])

  useEffect(() => {
    if (authState) {
      const onReceiveRoom = (msg: InboxNotificationModel) => {
        console.log("Inbox message", msg);
        dispatch(addIncomingInboxNotification(msg));
      }

      const soc = createSocket();
      soc.auth = { token: authState.accessToken };
      soc.io.opts.query = { type: SOCKET_CONNECTION_TYPE.INBOX };
      // socket.io.opts.forceNew = true;
      soc.connect();
      setNotificationsSocket(soc);

      soc.on('notification', onReceiveRoom);
      soc.emit('joinInbox', "");
      return () => {
        soc.off('notification', onReceiveRoom);
        soc.disconnect();
      };
    }
  }, [authState])

  useEffect(() => {
    console.log("launch app with initial state ", initialState);
  }, [initialState])

  useEffect(() => {
    if (notifications.length > prevNotifications.length) {
      ref.current?.(notifications[notifications.length - 1].message, notifications[notifications.length - 1].type);
    }
    setPrevNotifications([...notifications]);
  }, [notifications])

  useEffect(() => {
    if (authState?.accessToken) {
      api.defaults.headers.common['Authorization'] = "Bearer " + authState.accessToken;
      dispatch(setApiauthInitialized());
    } else {
      api.defaults.headers.common["Authorization"] = "";
      delete api.defaults.headers.common['Authorization'];
    }
  }, [authState])

  notificationsSocket?.on("testJoin", (e) => {
    console.log("CONNECTED INBOX ", e);
  })

  // TODO: add axios interceptor to navigate user to login page when unauthroized is returned

  const handleRemoveNotification = (key: number) => {
    dispatch(popNotification(key))
  }

  const handleBtnClick = async () => {
    const d = await makeTestRequest()
    console.log("D ", d)
  }

  return (
    <div className={`App ${scrollYEnabled ? '' : 'overflow-y-hidden overflow-x-hidden h-screen w-screen'}`}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
          {t("hello")}
        </a>
      </header> */}
        {/* <NotificationModal /> */}
        <NotificationHub children={(add) => {
          ref.current = add
        }} removeNotification={(k) => handleRemoveNotification(k)} />
        <RouterProvider router={router}></RouterProvider>
      </LocalizationProvider>
      {
        globalLoadingState &&
        <div className='fixed w-full h-full bg-slate-300/75 z-40 top-0 left-0 flex justify-center items-center'>
          <Spinner />
        </div>
      }
    </div>
  );
}

export default App;
